/**
 * Generated CRM child rows use a deterministic id so that re-deriving a family
 * produces the same ids and MUI DataGrid updates rows in place instead of
 * remounting them.
 *
 * Shape: `crm-<parentRowId>-i<n>`.
 *
 * Index is ONE-based and counts *generated children only*: instance `0` is
 * the parent/authored row itself (it keeps its own id, no prefix), so the
 * first generated child is `i1`, the second `i2`, and so on.
 *
 * Parentage is read from `crmSourceRowId` on the row (see `TableRowType`),
 * never parsed back out of the id — a parent row id may itself contain `-i`,
 * which would make parsing ambiguous. Do not add a `parseCrmChildRowId`.
 */
export const CRM_CHILD_ROW_ID_PREFIX = 'crm-';

export function buildCrmChildRowId(parentRowId: string, index: number): string {
  if (!parentRowId) {
    throw new TypeError('buildCrmChildRowId: parentRowId must be a non-empty string');
  }
  if (!Number.isInteger(index) || index < 1) {
    throw new TypeError('buildCrmChildRowId: index must be an integer >= 1 (0 is the parent/authored row, not a generated child)');
  }
  return `${CRM_CHILD_ROW_ID_PREFIX}${parentRowId}-i${index}`;
}

export function isCrmChildRowId(id: string): boolean {
  return id.startsWith(CRM_CHILD_ROW_ID_PREFIX);
}
